module.exports = {
  "id": "pot",
  "title": "pot",
  "image": "provision/parts/pot/pot.png",
  "info": [
    {
      "text": "Add pot of food to your project",
      "image": "provision/parts/pot/pot.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/pot/pot.png"
} ;